import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../admin.service';
import { IExtendedUserList } from '@models/general/user';
import { MatDialog } from '@angular/material/dialog';
import { DatasetListingService } from 'src/app/dataset-listing/dataset-listing.service';
import { Dataset } from '@models/mood/dataset';
import { ExternalReferenceType_ENUM } from '@models/mood/dataset-metainfo';
import { MatAccordionBase } from '@angular/material/expansion';
import { TopBarService } from 'src/app/top-bar/top-bar.service';

export interface GeonetworkEntry {
  identifier: string;
  title: string;
  type: 'dataset',
  subject: string[],
  abstract: string;
}

export interface GeonetworkLink extends GeonetworkEntry {
  datasets: Dataset[];
}

@Component({
  selector: 'mood-issues-list-admin',
  templateUrl: './issues-list.component.html',
  styleUrls: ['issues-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssuesListAdminComponent implements OnInit, OnDestroy {
  private _allGeonetworkLinks: GeonetworkLink[] = [];


  public missingGeonetworkLinks: Dataset[] = [];
  public invalidGeonetworkLinks: Dataset[] = [];

  private _allDatasets: Dataset[] = [];
  private _allGeonetworkDatasets: GeonetworkEntry[] = [];

  constructor(
    private _dataListingService: DatasetListingService,
    private _adminService: AdminService,
    private _changeDetector: ChangeDetectorRef,
    private _topBarService: TopBarService,
  )
  {
    this._topBarService.setTitle('Issues/troubleshooting');
  }

  ngOnDestroy(): void {
  }

  async ngOnInit() {
    this._allDatasets = await this._dataListingService.getDatasetListing();
    this._allGeonetworkDatasets = await this._adminService.getGeonetworkDatasets();

    this._allGeonetworkDatasets.forEach(geonetworkEntry => {
      this._allGeonetworkLinks.push({
        ...geonetworkEntry,
        datasets: []
      });
    });

    this._allDatasets.forEach(dataset => {
      const foundGeonetworkLink = dataset.external_references?.find(reference => reference.platform === ExternalReferenceType_ENUM.GEONETWORK);

      if (foundGeonetworkLink) {
        const existingLinkIndex = this._allGeonetworkLinks.findIndex(geonetwork => geonetwork.identifier === foundGeonetworkLink.identifier);

        if (existingLinkIndex === -1) {
          this.invalidGeonetworkLinks.push(dataset);
        } else {
          this._allGeonetworkLinks[existingLinkIndex].datasets.push(dataset);
          // this._allGeonetworkLinks.set(foundGeonetworkLink.identifier, existingLinkIndex);
        }
      } else {
        this.missingGeonetworkLinks.push(dataset);
      }
    });

    this._changeDetector.markForCheck();
  }

  public get geonetworkLinks() {
    return this._allGeonetworkLinks.filter(link => link.datasets.length > 0);
  }

  public get geonetworkNoLinks() {
    return this._allGeonetworkLinks.filter(link => link.datasets.length === 0);
  }
}
